"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_GIFT_QUANTITY = exports.GIFT_STATUSES = void 0;

/*
As a long term solution we will replace it with gift status ids
* */
var GIFT_STATUSES = {
  'Invite disabled': 'Disabled',
  'Invite delivered': 'Delivered',
  'Invite scheduled': 'Gift scheduled',
  'Invite in transit': 'Invitation In Transit',
  'Invite accepted': 'Accepted',
  'Invite declined': 'Declined',
  'Invite resent': 'Invite resent',
  'Follow up sent': 'Follow up sent',
  'Invite viewed': 'Invite viewed',
  'Gift accepted': 'Gift accepted',
  'Options ready': 'Options ready',
  'Invite processing': 'Invite processing',
  'Gift created': 'Gift created',
  'Meeting booked': 'Meeting booked',
  'Invite bounced': 'Link Generated',
  'Invite expired': 'Invite expired',
  'Gift declined': 'Gift declined',
  'Invite returned': 'Invite returned'
};
exports.GIFT_STATUSES = GIFT_STATUSES;
var DEFAULT_GIFT_QUANTITY = 1;
exports.DEFAULT_GIFT_QUANTITY = DEFAULT_GIFT_QUANTITY;